import { useNavigate } from "react-router-dom";
import {
  getNextPickupTime,
  getSelectedSearchOrderType,
  getSelectedTabListView,
  getStoreLocalData,
  getUserData,
  setNextPickupTime,
  setSelectedSearchOrderType,
  setSelectedTabListView,
} from "../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "./SchedularModal";
import StatusFilterModal from "./StatusFilterModal";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { storeOrdersWithPaginationAndSearch } from "../services/StoreOrder/StoreOrder";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate, maskMobileNumber } from "../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import TabMenu from "./TabMenu";
import StoreMenu from "./StoreMenu";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../ButtonLink";
import useOrders from "./StoreContext/useOrders";
import { postQrCodeByStatus } from "../services/QrCode/postQrCodeByStatus";
import { postBulkQrCode } from "../services/QrCode/postBulkQrCode";
import SuccessModal from "./SuccessModal";
import CollectPayment from "./OrderComponents/CollectPayment";
import ConfirmOrderUpdate from "./ConfirmOrderUpdate";
import { Toast } from "primereact/toast";
import { getStoreNewPick } from "../services/DashboardAPI/DashboardApi";
import PickupNotification from "../assets/sounds/pickup-notification.mp3"
import CollectPaymentSubscriptionClosedModal from "./OrderComponents/CollectPaymentSubscriptionClosedModal";

const { innerWidth: width, innerHeight: height } = window;

const Orders = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData, userProfileData } =
    getUserData();
  const { storeLocalData } = getStoreLocalData();

  const storeId = storeData.id;
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const enabledCustomerRevenueDetailV2 = storeData.enabledCustomerRevenueDetailV2;
  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;
  let enabledRfIdModal = brandProfileData.enabledRfIdModal;
  let enabledByPassOrderProcess = brandProfileData.enabledByPassOrderProcess;
  const storeUserId = userProfileData.id;
  let deliveryDiscount = storeData.enableDeliveryDiscount;
  let enableUserAccountDeliveryDiscount =
    storeData.enableUserAccountDeliveryDiscount;
  let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
  let enabledSubscriptionDiscountOnDelivery =
    storeData.enabledSubscriptionDiscountOnDelivery;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;
  
  const enabledDownloadData =  storeData.enabledDownloadData // Enable download report for all orders

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [confirmOrderUpdateModalVisible, setConfirmOrderUpdateModalVisible] = useState(false);
  const [confirmOrderUpdateType, setConfirmOrderUpdateType] =
    useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalStatusText, setModalStatusText] = useState("");
  // const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  // const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [page, setPage] = useState(0);
  // const [useEffectCall, setUseEffectCall] = useState(false);
  // const [statusTotalData, setStatusTotalData] = useState([]);
  // const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  // const [sumOfOrderCount, setSumOfOrderCount] = useState(0);
  const [visible, setVisible] = useState(false);
  // const [homeDeliveryValue, setHomeDeliveryValue] = useState(false);
  // const [urgentDeliveryValue, setUrgentDeliveryValue] = useState(false);

  const {
    schedularDate,
    setSchedularDate,
    selectedStatus,
    setSelectedStatus,
    customerALLOrdersData,
    setCustomerALLOrdersData,
    statusTotalData,
    setStatusTotalData,
    sumOfGrandTotal,
    setSumOfGrandTotal,
    sumOfOrderCount,
    setSumOfOrderCount,
    upDateSelectedStatus,
    setUpDateSelectedStatus,
    page,
    setPage,
    // searchTerm,
    // setSearchTerm,
    useEffectCall,
    setUseEffectCall,
    homeDeliveryValue,
    setHomeDeliveryValue,
    urgentDeliveryValue,
    setUrgentDeliveryValue,
  } = useOrders();

  const resetOrdersList = () => {
    const ordersStore = useOrders.getState();

    ordersStore.setPage(0); // reset page
    setPage(0); // reset local state

    // Reset Zustand store values
    ordersStore.setSchedularDate({});
    ordersStore.setSelectedStatus('ALL');
    ordersStore.setUpDateSelectedStatus([]);
    ordersStore.setSearchTerm('');
    ordersStore.setUseEffectCall(false);
    ordersStore.setHomeDeliveryValue(false);
    ordersStore.setUrgentDeliveryValue(false);
    ordersStore.setCustomerALLOrdersData([]);
    ordersStore.setStatusTotalData([]);
    ordersStore.setSumOfGrandTotal(0);
    ordersStore.setSumOfOrderCount(0);
    //  ordersStore.setPage(0);
    ordersStore.setSelectedStore('ALL');
    ordersStore.setUpDateSelectedStore([]);

    // Reset local search/filter states
    setSearchTerm('');
    setSearchTermClean(false);
    setHomeDeliveryValue(false);
    setUrgentDeliveryValue(false);

    // Reset requestData
    const initialRequestData = {
      storeIds: [storeId],
      brandId: brandId,
      statusIn: [
        'BOOKED',
        'INPROCESS',
        'IN_WAREHOUSE',
        'PROCESSED',
        'DELIVERED',
        'DONE',
        'CANCEL',
        'UNPROCESSED',
        'OUT_FOR_DELIVERY',
        'DELAY_STATUS',
      ],
      recordType: '',
      homeDelivery: false,
      urgentDelivery: false,
    };
    setRequestData(initialRequestData);

    // Explicitly fetch first page
    // fetch first page explicitly
    fetchStoreOrders(initialRequestData, 0); // pass 0 as page
  };


  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermClean, setSearchTermClean] = useState(false);
  const [searchFilterValue, setSearchFilterValue] = useState("INVOICE");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);
  const [collectPaymentModalVisible, setCollectPaymentModalVisible] =
    useState(false);
  const [collectPaymentSubscriptionClosedModalVisible, setCollectPaymentSubscriptionClosedModalVisible] =
    useState(false);
  const [selectedBalanceAmount, setSelectedBalanceAmount] = useState("");
  const [selectedStoreCustomerId, setSelectedStoreCustomerId] = useState("");
  const [selectedBookingOrderId, setSelectedBookingOrderId] = useState("");
  const [selectedSubscriptionDiscount, setSelectedSubscriptionDiscount] = useState("");
  const [selectedAppliedSubscriptionDiscount, setSelectedAppliedSubscriptionDiscount] = useState("");
  const [selectedPaidAmount, setSelectedPaidAmount] = useState("");

  const initializeVariable = () => {
    setCustomerALLOrdersData([]);
    updateStatusTotals([]);
  };

  const toast = useRef(null);
  const audioRef = useRef(null);
  const hasNotifiedRef = useRef(false);

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedStatus(selectedStatus);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchStoreOrders = (data, page = 0) => {
    setLoading(true);
    storeOrdersWithPaginationAndSearch(storeId, {
      ...data,
      sortOrder: "desc",
      sortBy: "id",
      limit: 100,
      offset: page * 100, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // if (page === 0) {
          //   setCustomerALLOrdersData(Res); // Reset state with new data
          //   updateStatusTotals(Res); // Calculate totals based on the fresh data
          // } else {
          //   setCustomerALLOrdersData((prevData) => [...prevData, ...Res]);
          //   updateStatusTotals([...customerALLOrdersData, ...Res]); // Calculate totals including additional data
          // }
          if (page === 0) {
            setCustomerALLOrdersData(Res);
            updateStatusTotals(Res);
          } else {
            setCustomerALLOrdersData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter((item) => !existingIds.has(item.id));
              const updatedData = [...prevData, ...newUniqueData];

              updateStatusTotals(updatedData); // Use combined, de-duped data
              return updatedData;
            });
          }

          setLoading(false);
          setLoadingSearch(false);
          setSearchTermClean(false);
          setIsEndReached(Res.length < 100);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
        setSearchTermClean(false);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [storeId],
    brandId: brandId,
    statusIn: [
      "BOOKED",
      "INPROCESS",
      "IN_WAREHOUSE",
      "PROCESSED",
      "DELIVERED",
      "DONE",
      "CANCEL",
      "UNPROCESSED",
      "OUT_FOR_DELIVERY",
      "DELAY_STATUS",
    ],
    recordType: "",
    homeDelivery: homeDeliveryValue ? "yes" : "no",
    urgentDelivery: urgentDeliveryValue ? "yes" : "no",
    // startDate: startDate,
    // endDate: endDate,
  };
  const [requestData, setRequestData] = useState(data);

  const showInfo = (data) => {
    toast.current?.show({
      severity: "info",
      summary: "Notification",
      detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
      life: 10000,
    });

    // 🔊 Play sound
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // restart sound
      audioRef.current.play().catch(() => {
        // autoplay might be blocked until user interaction
      });
    }
  };

  //  useEffect(() => {
  //    const unlockAudio = () => {
  //      if (audioRef.current) {
  //        audioRef.current.play().then(() => {
  //          audioRef.current.pause();
  //          audioRef.current.currentTime = 0;
  //        });
  //      }
  //      document.removeEventListener("click", unlockAudio);
  //    };

  //    document.addEventListener("click", unlockAudio);

  //    return () => document.removeEventListener("click", unlockAudio);
  //  }, []);

  const fetchStoreNewPick = async () => {
    try {
      const response = await getStoreNewPick(storeId);

      if (!response.data.error) {
        if (response.data > 0 && !hasNotifiedRef.current) {
          showInfo(response.data);
          hasNotifiedRef.current = true;
        }

        // reset when no pickup exists
        if (response.data === 0) {
          hasNotifiedRef.current = false;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (enabledNewPickupStoreNotified) {

      // Initialize timer if not present
      if (!getNextPickupTime()) {
        setNextPickupTime();
      }

      const interval = setInterval(() => {
        const nextTime = getNextPickupTime();
        const now = Date.now();

        if (now >= nextTime) {
          // ⏰ Time is zero → call API
          fetchStoreNewPick();

          // 🔄 Reset timer
          setNextPickupTime();
        }
      }, 1000); // check every second

      return () => clearInterval(interval);
    }
  }, [enabledNewPickupStoreNotified]);

  //  useEffect(() => {
  //    const interval = setInterval(() => {
  //      fetchStoreNewPick();
  //    }, 15000); // 15 seconds

  //    return () => clearInterval(interval);
  //  }, []);


  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      if (selectedStatus !== "ALL") {
        requestData.statusIn = selectedStatus;
      } else {
        requestData.statusIn = [
          "BOOKED",
          "INPROCESS",
          "IN_WAREHOUSE",
          "PROCESSED",
          "DELIVERED",
          "DONE",
          "CANCEL",
          "UNPROCESSED",
          "OUT_FOR_DELIVERY",
          "DELAY_STATUS",
        ];
      }
      // requestData.startDate = schedularDate?.startDate
      //   ? schedularDate.startDate
      //   : startDate;
      // requestData.endDate = schedularDate?.endDate
      //   ? schedularDate.endDate
      //   : endDate;

      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      setPage(0);
      fetchStoreOrders(requestData, page);
    }
  }, [schedularDate, selectedStatus, searchTermClean]);

  useEffect(() => {
    fetchStoreOrders(data, page);
    fetchSelectedSearchType();
    fetchSelectedTabListView();
  }, []);

  const fetchSelectedSearchType = async () => {
    const selectedSearchTypeData = await getSelectedSearchOrderType();
    if (selectedSearchTypeData.searchOrderType !== null) {
      setSearchFilterValue(selectedSearchTypeData.searchOrderType);
    } else {
      setSearchFilterValue("");
    }
  };

  useEffect(() => {
    const requestValue = {
      ...requestData,
      searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
      searchText: searchTerm,
    };
    if (page > 0) fetchStoreOrders(requestValue, page);
  }, [page]);

  const homeDeliveryFilter = (homeDelivery) => {
    setHomeDeliveryValue(homeDelivery);
    const requestValue = {
      ...data,
      homeDelivery: homeDelivery ? "yes" : "no",
    };
    fetchStoreOrders(requestValue, page);
  };

  const urgentDeliveryFilter = (urgentDelivery) => {
    setUrgentDeliveryValue(urgentDelivery);
    const requestValue = {
      ...data,
      urgentDelivery: urgentDelivery ? "yes" : "no",
    };
    fetchStoreOrders(requestValue, page);
  };

  const searchTermApiCall = (term) => {
    if (term) {
      setSearchTerm(term);
      setLoadingSearch(true);
      setPage(0);
      const requestValue = {
        storeIds: [storeId],
        brandId: brandId,
        recordType: "",
        statusIn: [
          "BOOKED", "INPROCESS", "IN_WAREHOUSE", "PROCESSED", "DELIVERED",
          "DONE", "CANCEL", "UNPROCESSED", "OUT_FOR_DELIVERY", "DELAY_STATUS",
        ],
        startDate: null,
        endDate: null,
        offset: 0,
        searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
        searchText: term,
      };
      fetchStoreOrders(requestValue, page);
    } else {
      setSearchTerm("");
      setLoadingSearch(true);
      setUseEffectCall(true);
      setPage(0);
      setSearchTermClean(true);
    }
  };

  const SearchBar = React.memo(function SearchBar({
      searchFilterValue,
      onSearch,
      onClear,
      onToggleFilterType,
    }) {
      const [value, setValue] = useState("");
  
      const placeholder =
        searchFilterValue === "NAME"
          ? "Search By Name"
          : searchFilterValue === "MOBILE"
            ? "Search By Mobile No."
            : "Search By Invoice No.";
  
      return (
        <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={placeholder}
                value={value}
                keyboardType={searchFilterValue === "NAME" ? "default" : "numeric"}
                onChange={(e) => setValue(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>
  
          {value ? (
            <div className="flex mx-2 gap-3">
              <div
                style={{ backgroundColor: "#2B70D7" }}
                className="px-3 py-2 border-round-md cursor-pointer"
                onClick={() => onSearch(value)}
              >
                <p className="text-white text-lg font-bold uppercase">Search</p>
              </div>
              <div
                style={{ backgroundColor: "#d72b2bff" }}
                className="px-3 border-round-md cursor-pointer"
                onClick={() => {
                  setValue("");
                  onClear();
                }}
              >
                <p className="text-4xl font-bold" style={{ color: "#fff" }}> X</p>
              </div>
            </div>
          ) : (
            <div
              onClick={onToggleFilterType}
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: 27 }}
                />
              </div>
            </div>
          )}
        </div>
      );
    });

     const handleSearch = useCallback((term) => {
        searchTermApiCall(term);
      }, [searchFilterValue, storeId, brandId, page]);
    
      const handleClear = useCallback(() => {
        handleClearSearch();
      }, []);
    
      const handleToggleFilterType = useCallback(() => {
        handleSearchType();
      }, [])

  // const searchTermApiCall = () => {
  //   if (searchTerm !== "") {
  //     setLoadingSearch(true);
  //     setPage(0);
  //     const requestValue = {
  //       // ...requestData,
  //       storeIds: [storeId],
  //       brandId: brandId,
  //       recordType: "",
  //       statusIn: [
  //         "BOOKED",
  //         "INPROCESS",
  //         "IN_WAREHOUSE",
  //         "PROCESSED",
  //         "DELIVERED",
  //         "DONE",
  //         "CANCEL",
  //         "UNPROCESSED",
  //         "OUT_FOR_DELIVERY",
  //         "DELAY_STATUS",
  //       ],
  //       startDate: null,
  //       endDate: null,
  //       offset: 0,
  //       searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
  //       searchText: searchTerm,
  //     };
  //     fetchStoreOrders(requestValue, page);
  //   } else {
  //     setSearchTerm("");
  //     setLoadingSearch(true);
  //     setUseEffectCall(true);
  //     setPage(0);
  //     setSearchTermClean(true);
  //   }
  // };

  // const searchTermApiCall = (text) => {
  //   if (text !== "") {
  //     setLoadingSearch(true);
  //     setSearchTerm(text);
  //     setPage(0);
  //     const requestValue = {
  //       // ...requestData,
  //       storeIds: [storeId],
  //       brandId: brandId,
  //       recordType: "",
  //       statusIn: [
  //         "BOOKED",
  //         "INPROCESS",
  //         "IN_WAREHOUSE",
  //         "PROCESSED",
  //         "DELIVERED",
  //         "DONE",
  //         "CANCEL",
  //         "UNPROCESSED",
  //         "OUT_FOR_DELIVERY",
  //         "DELAY_STATUS",
  //       ],
  //       startDate: null,
  //       endDate: null,
  //       offset: 0,
  //       searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
  //       searchText: text,
  //     };
  //     fetchStoreOrders(requestValue);
  //   } else {
  //     setSearchTerm("");
  //     setLoadingSearch(true);
  //     setUseEffectCall(true);
  //     setPage(0);
  //     setSearchTermClean(true);
  //   }
  // };

  // const getData = () => {
  //   if (!isEndReached && !loading) {
  //     // Increase the page number and fetch the data
  //     setPage((prevPage) => {
  //       const newPage = prevPage + 1;
  //       fetchStoreOrders({ ...requestData, offset: newPage * 10 });
  //       return newPage;
  //     });
  //   }
  // };

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

  useEffect(() => {
    if (collectPaymentResponse === false) {
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  const receiveResponse = ({ message, status, modalFun }) => {
    setModalStatusText(status ? "success" : "failed");
    setModalText(message);
    setCollectPaymentResponse(modalFun);

    setSelectedBalanceAmount("");
    setSelectedStoreCustomerId("");
    setSelectedBookingOrderId("");
    setSelectedSubscriptionDiscount("");
    setSelectedAppliedSubscriptionDiscount("");
    setSelectedPaidAmount("");

    fetchStoreOrders(data, page);
    fetchSelectedSearchType();
    fetchSelectedTabListView();
  };

  const receiveDataFromConfirmModal = ({ success, confirmOrderUpdateTypeRes }) => {
    if (success) {
      if (confirmOrderUpdateTypeRes === "MarkedReady") {
        handleDirectMarkReady(selectedStoreCustomerId, selectedBookingOrderId);
      } else {
        handleDirectDelivery(selectedStoreCustomerId, selectedBookingOrderId);
      }
    } else {
      setSelectedStoreCustomerId("");
      setSelectedBookingOrderId("");
    }
  };

  const handleDirectMarkReady = (storeCustomerId, bookingOrderId) => {
    const dataDirectMarkReady = {
      status: ["IN_PROCESS"],
    };
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, dataDirectMarkReady)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const qrCodeArray = Res.map((item) => item.qrcode);
          const bulkQrData = {
            qrcodeList: qrCodeArray,
            status: "PROCESSED",
            remark: "ready now",
          };

          postBulkQrCode(storeCustomerId, storeId, bookingOrderId, bulkQrData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;

                setModalVisible(true);
                setModalStatusText(Res.status === true ? "success" : false);
                if (Res.status) {

                  fetchStoreOrders(data, page);
                  fetchSelectedSearchType();
                  fetchSelectedTabListView();

                  setSelectedStoreCustomerId("");
                  setSelectedBookingOrderId("");

                  //  const timer = setTimeout(() => {
                  //    navigate("/PaymentCollection", {
                  //      state: {
                  //        storeCustomerId: storeCustomerId,
                  //        bookingOrderId: bookingOrderId,
                  //      },
                  //    });
                  //  }, 1200);
                  //  return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleDirectDelivery = (storeCustomerId, bookingOrderId) => {
    const dataDirectDelivery = {
      status: ["PROCESSED", "UNPROCESSED"],
    };
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, dataDirectDelivery)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const qrCodeArray = Res.map((item) => item.qrcode);
          const bulkQrData = {
            qrcodeList: qrCodeArray,
            status: "READY_TO_DELIVER_BY_STORE",
            remark: "ready now",
          };

          if (qrCodeArray.length > 0) {
            postBulkQrCode(storeCustomerId, storeId, bookingOrderId, bulkQrData)
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;

                  setModalVisible(true);
                  setModalStatusText(Res.status === true ? "success" : false);
                  if (Res.status) {
                    const timer = setTimeout(() => {
                      navigate("/PaymentCollection", {
                        state: {
                          storeCustomerId: storeCustomerId,
                          bookingOrderId: bookingOrderId,
                        },
                      });
                    }, 1200);
                    return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          } else {
            navigate("/PaymentCollection", {
              state: {
                storeCustomerId: storeCustomerId,
                bookingOrderId: bookingOrderId,
              },
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };

  // Update status totals based on fetched data
  const updateStatusTotals = (orders) => {
    const statusTotals = orders.reduce((acc, order) => {
      const existingStatus = acc.find((item) => item.status === order.status);

      if (existingStatus) {
        existingStatus.grandTotalSum += order.grandTotal;
        existingStatus.orderCount += 1;
      } else {
        acc.push({
          status: order.status,
          grandTotalSum: order.grandTotal,
          orderCount: 1,
        });
      }
      return acc;
    }, []);

    const totalGrandTotalSumData = statusTotals.reduce(
      (acc, item) => acc + item.grandTotalSum,
      0
    );
    const totalOrderCountData = statusTotals.reduce(
      (acc, item) => acc + item.orderCount,
      0
    );

    setStatusTotalData(statusTotals);
    setSumOfGrandTotal(totalGrandTotalSumData);
    setSumOfOrderCount(totalOrderCountData);
  };

  const handleSearchFilterChange = async (selectedItem) => {
    setSearchFilterValue(selectedItem);
    handleSearchType();
    await setSelectedSearchOrderType(selectedItem);
  };

  const FilterList = [
    {
      name: "By Name",
      value: "NAME",
    },
    {
      name: "By Invoice No.",
      value: "INVOICE",
    },
    {
      name: "By Mobile No.",
      value: "MOBILE",
    },
  ];

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setLoadingSearch(true);
    setUseEffectCall(true);
    setPage(0);
    setSearchTermClean(true);
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const renderPaymentModeButtons = () => {
    return statusTotalData.map((item) => (
      <div
        key={item.status}
        style={{ backgroundColor: OrderStatusColors[item.status] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount} - {item.status.replace(/_/g, " ")} ({storeLocalData?.currencySymbol}{" "}
          {item.grandTotalSum.toFixed(0)})
        </p>
      </div>
    ));
  };

  const itemTemplate = (data) => {

    const index = customerALLOrdersData.findIndex(
      item => item === data
    );

    const orderStatusColor =
      OrderStatusColors[data.status] || OrderStatusColors.DEFAULT;
    const displayDate =
      data.status === "DELIVERED" || data.status === "DONE"
        ? data.deliveredOn
        : data.deliveryOn;
    const displayBalanceText =
      data.status === "DELIVERED"
        ? '| Balance'
        : '';
    const displayBalanceAmount =
      data.status === "DELIVERED"
        ? '| ' + data.balanceAmount
        : '';
    const displayDeliveryDateText =
      data.status === "DELIVERED" || data.status === "DONE"
        ? "Delivered On"
        : "Delivery Date";
    const formattedCreatedDate = formatDateNew(data.createdDate);
    const formattedDeliveryDate = formatDateNew(displayDate);

    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
          <AccordionTab
            key={data.id || data.invoiceNo || data.orderNo} // Use a more unique key like data.id
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
            }}
            header={`${data.invoiceNo || "N/A"
              } | ${formattedCreatedDate} ${data.status.replace(
                /_/g,
                " "
              )}  -> ( DD - ${formattedDeliveryDate} | ${data.customerName || "N/A"
              } | ${storeLocalData?.currencySymbol} ${data.grandTotal || "N/A"} | IC - ${data.itemGarmentCount
              }  ) ${data.urgentDelivery ? " | U " : ""}  ${data.deliveryRequest ? " | H " : ""
              }`}
          >
            <div
              className="cursor-pointer"
              onClick={() =>
                userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
                  ? navigate("/OrdersGarmentInfo", {
                    state: {
                      storeIdValue: data.storeId,
                      bookingOrderId: data.id,
                      bookingOrderNo: data.orderNo,
                      storeCustomerId: data.storeCustomerId,
                    },
                  })
                  : navigate("/OrdersGarmentInfo", {
                    state: {
                      bookingOrderId: data.id,
                      bookingOrderNo: data.orderNo,
                      storeCustomerId: data.storeCustomerId,
                      navigateThrough: "GoBack",
                    },
                  })
              }
            >
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Order No:</p>
                  <p className="text-lg font-bold capitalize">
                    {data.orderNo || "N/A"}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Invoice No:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {data.invoiceNo || "N/A"}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Order Source:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {data.orderSource
                      ? data.orderSource.replace(/_/g, " ")
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Customer Name:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {data.customerName || "N/A"}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Customer Mobile No.:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {maskMobileNumber(data.customerMobile) || "N/A"}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Remarks:</p>
                  <p className="text-lg font-bold capitalize">
                    {data.remarks || "N/A"}
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    {displayDeliveryDateText}:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {formattedDeliveryDate}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Invoice {displayBalanceText} Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {data.grandTotal} {displayBalanceAmount}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Status:</p>
                  <p className="text-lg font-bold capitalize">
                    <span style={{ color: orderStatusColor }}>
                      {data.status || "Unknown"}
                    </span>
                  </p>
                </div>
              </div>

              <div className="flex-row">
                <div className="col-8">
                  <p className="text-base font-semiBold capitalize">Address:</p>
                  <p className="text-lg font-bold capitalize">
                    {data.customerAddress}
                  </p>
                </div>
                {data.deliveryRemarks && (
                  <div className="col-4">
                    <p className="text-base font-semiBold capitalize">
                      Delivery Remark:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {data.deliveryRemarks}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    );
  };

  // const footer = (
  //   <Button
  //     type="text"
  //     icon="pi pi-plus"
  //     label="Load"
  //     onClick={getData} // Update this to trigger `getData`
  //   />
  // );
  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListView();
      setTabularView(selectedInvoiceTypeData?.tabListView || "list");
    } catch {
      setTabularView("list");
    }
  };

  const BalanceAmountTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between gap-2">
        <div>
          <span className="text-md">{rowData.balanceAmount}</span>
        </div>
        {rowData.balanceAmount > 0 &&
          ["BOOKED", "PROCESSED", "INPROCESS", "IN_WAREHOUSE"].includes(
            rowData.status
          ) && rowData.appliedSubscriptionDiscount === false &&
                  rowData.subscriptionDiscount === 0 && (
            <div
              className="cursor-pointer"
              onClick={() => {
                
                  setCollectPaymentModalVisible(true);
                setSelectedBalanceAmount(rowData.balanceAmount);
                setSelectedStoreCustomerId(rowData.storeCustomerId);
                setSelectedBookingOrderId(rowData.id);
                setSelectedSubscriptionDiscount(rowData.subscriptionDiscount);
                setSelectedAppliedSubscriptionDiscount(
                  rowData.appliedSubscriptionDiscount
                );
                setSelectedPaidAmount(rowData.paidAmount);
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                style={{
                  // height: 31,
                  width: 21,
                  // backgroundColor: "#FFF9DE",
                  // borderColor: "#F5C43A",
                }}
              />
            </div>
          )}
        {rowData.balanceAmount > 0 &&
          ["DELIVERED"].includes(rowData.status) && (
            <div
              className="cursor-pointer"
              onClick={() => {

                // rowData.appliedSubscriptionDiscount === false &&
                //   rowData.subscriptionDiscount === 0 &&
                if (rowData.appliedSubscriptionDiscount &&
                  rowData.subscriptionDiscount > 0 &&
                  rowData.paidAmount > 0 && rowData.balanceAmount > 0) {
                  setCollectPaymentSubscriptionClosedModalVisible(true);
                } else {
                  setCollectPaymentModalVisible(true);
                }
                setSelectedBalanceAmount(rowData.balanceAmount);
                setSelectedStoreCustomerId(rowData.storeCustomerId);
                setSelectedBookingOrderId(rowData.id);
                setSelectedSubscriptionDiscount(rowData.subscriptionDiscount);
                setSelectedAppliedSubscriptionDiscount(
                  rowData.appliedSubscriptionDiscount
                );
                setSelectedPaidAmount(rowData.paidAmount);
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                style={{
                  // height: 31,
                  width: 21,
                  // backgroundColor: "#FFF9DE",
                  // borderColor: "#F5C43A",
                }}
              />
            </div>
          )}
      </div>
    );
  };

  const PcsBodyTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between gap-2">
        <div
          style={{ backgroundColor: "#09B4AA" }}
          className="px-2 border-round-md cursor-pointer"
          onClick={() =>
            navigate("/GarmentTags", {
              state: {
                bookingOrderId: rowData.id,
                storeCustomerId: rowData.storeCustomerId,
                orderItemId: null,
                customerALLOrdersData,
                isOrders: true,
              },
            })
          }
        >
          <span className="text-white text-lg font-bold uppercase">
            {rowData.itemGarmentCount}
          </span>
        </div>
        {enabledByPassOrderProcess &&
          userRole === "BY_STORE" &&
          rowData.status === "PROCESSED" && (
            <div
              className="cursor-pointer"
              onClick={() => {
                setConfirmOrderUpdateModalVisible(true);
                setConfirmOrderUpdateType("DirectDelivery");
                setSelectedStoreCustomerId(rowData.storeCustomerId);
                setSelectedBookingOrderId(rowData.id);
              }
                // handleDirectDelivery(rowData.storeCustomerId, rowData.id)
              }
            >
              <img
                src={"warehouse/delivery-boy.png"}
                style={{
                  // height: 31,
                  width: 21,
                  // backgroundColor: "#FFF9DE",
                  // borderColor: "#F5C43A",
                }}
              />
            </div>
          )}
        {userRole === "BY_STORE" && rowData.status === "BOOKED" && (
          <div
            className="cursor-pointer"
            onClick={() =>
            // handleDirectMarkReady(rowData.storeCustomerId, rowData.id)
            {
              setConfirmOrderUpdateModalVisible(true);
              setConfirmOrderUpdateType("MarkedReady");
              setSelectedStoreCustomerId(rowData.storeCustomerId);
              setSelectedBookingOrderId(rowData.id);
            }
            }
          >
            <img
              src={"images/checked.png"}
              style={{
                // height: 31,
                width: 21,
                // backgroundColor: "#FFF9DE",
                // borderColor: "#F5C43A",
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <div
        className="flex flex-row justify-content-between cursor-pointer"
        onClick={() =>
          navigate("/ViewInvoice", {
            state: {
              bookingOrderId: rowData.id,
              storeCustomerId: rowData.storeCustomerId,
              navigateThrough: "GoBack",
            },
          })
        }
      >
        <span style={{ color: OrderStatusColors[rowData.status] }}>
          {rowData?.status?.replace(/_/g, " ")}
        </span>
        <img
          src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
          style={{
            // height: 31,
            width: 21,
            backgroundColor: "#FFF9DE",
            borderColor: "#F5C43A",
          }}
        />
      </div>
    );
  };

  const urgentDeliveryTemplate = (rowData) => {
    return rowData?.urgentDelivery ? (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
        }
        style={{ width: "25" }}
      />
    ) : (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
        }
        style={{ width: "25" }}
      />
    );
  };

  const homeDeliveryTemplate = (rowData) => {
    return rowData?.deliveryRequest ? (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
        }
        style={{ width: "15" }}
      />
    ) : (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
        }
        style={{ width: "15" }}
      />
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
        onClick={() =>
          userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
            ? navigate("/OrdersGarmentInfo", {
              state: {
                storeIdValue: rowData.storeId,
                bookingOrderId: rowData.id,
                bookingOrderNo: rowData.orderNo,
                storeCustomerId: rowData.storeCustomerId,
              },
            })
            : navigate("/OrdersGarmentInfo", {
              state: {
                bookingOrderId: rowData.id,
                bookingOrderNo: rowData.orderNo,
                storeCustomerId: rowData.storeCustomerId,
                navigateThrough: "GoBack",
              },
            })
        }
      >
        <span style={{ color: "blue", textDecoration: "underline" }}>
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };

  const customerName = (rowData) => {
    return (
      <div>
        <p>
          {rowData?.customerName?.replace(/_/g, " ").substring(0, 16)}
          {rowData?.customerName?.length > 16 ? "..." : ""}
        </p>
      </div>
    );
  }

  const customerMobileNumber = (rowData) => {
    return (
      <div>
        <p>
          {maskMobileNumber(rowData?.customerMobile?.replace(/_/g, " "))}
        </p>
      </div>
    );
  }

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={100}
        rowsPerPageOptions={[50, 75, 100]}
        tableStyle={{ minWidth: "120rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 280}
      >
        <Column
          header="S No."
          style={{ width: "70px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "85px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        ></Column>
        <Column
          field="createdDate"
          header="Booking Date"
          style={{
            width: "110px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => formatDateNew(rowData?.createdDate)}
        />
        <Column
          field="deliveryOn"
          header="Due Date"
          style={{
            width: "110px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) =>
            rowData.status === "DELIVERED" || rowData.status === "DONE"
              ? formatDateNew(rowData.deliveredOn)
              : formatDateNew(rowData.deliveryOn)
          }
        ></Column>
        <Column
          field="customerName"
          header="Customer Name"
          style={{
            width: "140px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={customerName}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          style={{
            width: "100px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={customerMobileNumber}
        ></Column>
        <Column
          field="status"
          header="Status"
          style={{
            width: "170px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={statusBodyTemplate}
        ></Column>
        {/* <Column
          field="orderNo"
          header="Order No"
          body={(rowData) => rowData?.orderNo}
        /> */}

        <Column
          field="itemGarmentCount"
          header="Pcs"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          // body={(rowData) => rowData?.itemGarmentCount}
          body={PcsBodyTemplate}
        ></Column>
        <Column
          field="grandTotal"
          header="Amount"
          style={{
            width: "65px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{
            width: "65px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={BalanceAmountTemplate}
        ></Column>
        <Column
          field="urgentDelivery"
          header="UD"
          style={{
            width: "30px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={urgentDeliveryTemplate}
        // body={(rowData) => (rowData?.urgentDelivery ? "YES" : "NO")}
        ></Column>
        <Column
          field="deliveryRequest"
          header="HD"
          style={{
            width: "30px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={homeDeliveryTemplate}
        // body={(rowData) => (rowData?.deliveryRequest ? "YES" : "NO")}
        ></Column>
        {/* <Column field="customerName" header="Customer Name"></Column>
        <Column field="customerMobile" header="Customer Mobile"></Column> */}
        {/* <Column
          field="deliveredOn"
          header="Delivered On"
          body={(rowData) => rowData.status === "DELIVERED" || rowData.status === "DONE"
            ? formatDate(rowData.deliveredOn) : ""}
        ></Column> */}

        <Column
          field="orderSource"
          header="Order Source"
          style={{
            width: "100px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.orderSource?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="remarks"
          header="Remarks"
          style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
        ></Column>
        <Column
          field="deliveryRemarks"
          header="Delivery Remarks"
          style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
        ></Column>
      </DataTable>
    );
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredOrderInfoData = filterData(customerALLOrdersData, searchTerm);

  // const exportExcel = () => {
  //   import("xlsx").then((xlsx) => {
  //     // Map only the required fields for export
  //     const exportData = filteredOrderInfoData.map((item) => ({
  //       "Invoice No": item.invoiceNo,
  //       "Booking Date": formatDateNew(item.createdDate),
  //       "Due Date":
  //         item.status === "DELIVERED" || item.status === "DONE"
  //           ? formatDateNew(item.deliveredOn)
  //           : formatDateNew(item.deliveryOn),
  //       "Customer Name": item.customerName?.replace(/_/g, " "),
  //       Mobile: item.customerMobile,
  //       Status: item.status?.replace(/_/g, " "),
  //       Pcs: item.itemGarmentCount,
  //       Amount: item.grandTotal,
  //       Balance: item.balanceAmount,
  //       UD: item.urgentDelivery ? "Yes" : "No",
  //       HD: item.deliveryRequest ? "Yes" : "No",
  //       "Order Source": item.orderSource?.replace(/_/g, " "),
  //       Remarks: item.remarks,
  //       "Delivery Remarks": item.deliveryRemarks,
  //     }));

  //     const worksheet = xlsx.utils.json_to_sheet(exportData);
  //     const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  //     const excelBuffer = xlsx.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //     });

  //     saveAsExcelFile(excelBuffer, "My_Orders");
  //   });
  // };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const exportData = filteredOrderInfoData.map((item) => ({
        "Invoice No": item.invoiceNo,
        "Booking Date": formatDateNew(item.createdDate),
        "Due Date":
          item.status === "DELIVERED" || item.status === "DONE"
            ? formatDateNew(item.deliveredOn)
            : formatDateNew(item.deliveryOn),
        "Customer Name": item.customerName?.replace(/_/g, " "),
        Mobile: maskMobileNumber(item.customerMobile),
        Status: item.status?.replace(/_/g, " "),
        Pcs: item.itemGarmentCount || 0,
        Amount: item.grandTotal || 0,
        Balance: item.balanceAmount || 0,
        UD: item.urgentDelivery ? "Yes" : "No",
        HD: item.deliveryRequest ? "Yes" : "No",
        "Order Source": item.orderSource?.replace(/_/g, " "),
        Remarks: item.remarks,
        "Delivery Remarks": item.deliveryRemarks,
      }));

      // 👉 Calculate totals
      const totals = exportData.reduce(
        (acc, row) => {
          acc.Pcs += row.Pcs;
          acc.Amount += row.Amount;
          acc.Balance += row.Balance;
          return acc;
        },
        { Pcs: 0, Amount: 0, Balance: 0 }
      );

      // 👉 Add total row
      exportData.push({
        "Invoice No": "TOTAL",
        "Booking Date": "",
        "Due Date": "",
        "Customer Name": "",
        Mobile: "",
        Status: "",
        Pcs: totals.Pcs,
        Amount: totals.Amount,
        Balance: totals.Balance,
        UD: "",
        HD: "",
        "Order Source": "",
        Remarks: "",
        "Delivery Remarks": "",
      });

      const worksheet = xlsx.utils.json_to_sheet(exportData);

      const workbook = {
        Sheets: { data: worksheet },
        SheetNames: ["data"],
      };

      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "My_Orders");
    });
  };


  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                All Orders
              </p>
            </div>
          </div>
          {userRole === "BY_STORE" && enabledRfIdModal && (
            <div className="mx-2 cursor-pointer">
              <div
              title="Check Garment RFID"
                className="relative"
                onClick={() =>
                  navigate("/CheckGarmentRFID", {
                    state: {
                      storeCustomerId: null,
                      bookingOrderId: null,
                      navThrough: "orders",
                    },
                  })
                }
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: 2,
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png"}
                    style={{
                      width: 30,
                      height: 30,
                    }}
                    alt="qrcode"
                  />
                </div>
              </div>
            </div>
          )}
          {enabledDownloadData && (
            <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                title="Download Orders"
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                  width: 30,
                }}
              />
            </div>
          </div>)}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>
          <div className="flex justify-content-center align-items-center cursor-pointer">
            <div className="flex flex-1 justify-content-between my-1">
              <p className="text-xl text-white font-medium mx-3">HD</p>
              <Checkbox
                checked={homeDeliveryValue}
                size="20" // Increased size
                color={homeDeliveryValue ? "#00A3FF" : "#C1C9D3"}
                onClick={() => homeDeliveryFilter(!homeDeliveryValue)}
              />
            </div>
          </div>
          <div className="flex justify-content-center align-items-center cursor-pointer mr-2">
            <div className="flex flex-1 justify-content-between my-1">
              <p className="text-xl text-white font-medium  mx-3">UD</p>
              <Checkbox
                checked={urgentDeliveryValue}
                size="20" // Increased size
                color={urgentDeliveryValue ? "#00A3FF" : "#C1C9D3"}
                onClick={() => urgentDeliveryFilter(!urgentDeliveryValue)}
              />
            </div>
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
            title="Add Calendar"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
            title="Filter Orders by Status"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => resetOrdersList()}
            className="mx-2 cursor-pointer"
            title="Reset Filters"
          >
            <img src={"images/closeFilter.png"} style={{ width: 27 }} />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="  my-2">
        {customerALLOrdersData.length > 0 && enabledCustomerRevenueDetailV2 && (
          <div
            className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{ backgroundColor: "#2B70D7" }}
              className="px-3 py-2 border-round-md"
            >
              <p className="text-white text-lg font-bold uppercase">
                {sumOfOrderCount} - All ({storeLocalData?.currencySymbol} {sumOfGrandTotal.toFixed(0)})
              </p>
            </div>

            {renderPaymentModeButtons()}
          </div>
        )}

        <SearchBar
          searchFilterValue={searchFilterValue}
          onSearch={handleSearch}
          onClear={handleClear}
          onToggleFilterType={handleToggleFilterType}
        />
        {searchTypeToggle && (
          <div className="flex-1 mx-5 mb-4">
            <Dropdown
              value={searchFilterValue}
              onChange={(e) => handleSearchFilterChange(e.value)}
              options={FilterList}
              optionLabel="name"
              placeholder="Search Filter"
              className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
            />
          </div>
        )}
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : customerALLOrdersData?.length > 0 ? (
          <div>
            <div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                >
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: tabularView === "tab" ? "none" : "" }}>
              <DataScroller
                value={customerALLOrdersData}
                itemTemplate={itemTemplate}
                rows={customerALLOrdersData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 230}
                loader
              // footer={footer}
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Order Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 80, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>

        <TabMenu />

        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
        <StatusFilterModal
          setStatusFilterModalVisible={setStatusFilterModalVisible}
          statusFilterModalVisible={statusFilterModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
          upDateSelectedStatus={upDateSelectedStatus}
          OrderStatus={[
            "BOOKED",
            "INPROCESS",
            "IN_WAREHOUSE",
            "PROCESSED",
            "DELIVERED",
            "DONE",
            "CANCEL",
            "UNPROCESSED",
            "OUT_FOR_DELIVERY",
            "DELAY_STATUS",
          ]}
        />
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatusText}
          text={modalText}
        />

        <ConfirmOrderUpdate
          setConfirmOrderUpdateModalVisible={setConfirmOrderUpdateModalVisible}
          confirmOrderUpdateModalVisible={confirmOrderUpdateModalVisible}
          confirmOrderUpdateType={confirmOrderUpdateType}
          sendDataToConfirmOrderUpdate={receiveDataFromConfirmModal}
        />

        {userRole === "BY_STORE" &&
          <>
            {collectPaymentModalVisible && (
              <CollectPayment
                setCollectPaymentModalVisible={setCollectPaymentModalVisible}
                collectPaymentModalVisible={collectPaymentModalVisible}
                balanceAmount={selectedBalanceAmount}
                storeCustomerId={selectedStoreCustomerId}
                storeId={storeId}
                storeUserId={storeUserId}
                bookingOrderId={selectedBookingOrderId}
                sendResponse={receiveResponse}
                onClose={() => {
                  setSelectedBalanceAmount("");
                  setSelectedStoreCustomerId("");
                  setSelectedBookingOrderId("");
                  setSelectedSubscriptionDiscount("");
                  setSelectedAppliedSubscriptionDiscount("");
                  setSelectedPaidAmount("");

                  fetchStoreOrders(data, page);
                  fetchSelectedSearchType();
                  fetchSelectedTabListView();
                }}
                deliveryDiscount={deliveryDiscount}
                enableUserAccountDeliveryDiscount={
                  enableUserAccountDeliveryDiscount
                }
                enabledCreatePaymentLink={enabledCreatePaymentLink}
                brandId={brandId}
                enabledSubscriptionDiscountOnDelivery={
                  enabledSubscriptionDiscountOnDelivery
                }
                subscriptionDiscount={selectedSubscriptionDiscount}
                appliedSubscriptionDiscount={selectedAppliedSubscriptionDiscount}
                paidAmount={selectedPaidAmount}
                userProfileData={userProfileData}
                enabledAmountRoundOff={enabledAmountRoundOff}
              />)}
            {collectPaymentSubscriptionClosedModalVisible && (
              <CollectPaymentSubscriptionClosedModal
                setCollectPaymentSubscriptionClosedModalVisible={setCollectPaymentSubscriptionClosedModalVisible}
                collectPaymentSubscriptionClosedModalVisible={collectPaymentSubscriptionClosedModalVisible}
                balanceAmount={selectedBalanceAmount}
                storeCustomerId={selectedStoreCustomerId}
                storeId={storeId}
                storeUserId={storeUserId}
                bookingOrderId={selectedBookingOrderId}
                sendResponse={receiveResponse}
                onClose={() => {
                  setSelectedBalanceAmount("");
                  setSelectedStoreCustomerId("");
                  setSelectedBookingOrderId("");
                  setSelectedSubscriptionDiscount("");
                  setSelectedAppliedSubscriptionDiscount("");
                  setSelectedPaidAmount("");

                  fetchStoreOrders(data, page);
                  fetchSelectedSearchType();
                  fetchSelectedTabListView();
                }}
                deliveryDiscount={deliveryDiscount}
                enableUserAccountDeliveryDiscount={
                  enableUserAccountDeliveryDiscount
                }
                enabledCreatePaymentLink={enabledCreatePaymentLink}
                brandId={brandId}
                enabledSubscriptionDiscountOnDelivery={
                  enabledSubscriptionDiscountOnDelivery
                }
                subscriptionDiscount={selectedSubscriptionDiscount}
                appliedSubscriptionDiscount={selectedAppliedSubscriptionDiscount}
                paidAmount={selectedPaidAmount}
                userProfileData={userProfileData}
                enabledAmountRoundOff={enabledAmountRoundOff}
              />
            )}
          </>
        }
        <StoreMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
        <audio
          ref={audioRef}
          preload="auto"
          // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
          src={PickupNotification}
        />
        <div className="flex justify-content-center">
          <Toast ref={toast} />
        </div>
      </div>
    </div>
  );
};

export default Orders;
